/**
 * Init
 */
function init() {
  document.querySelectorAll('.at-nav-dropdown__item').forEach((secondLevel) => {
    secondLevel.addEventListener('mouseenter', () => {
      secondLevel.classList.add('at-hover');
      const toshow = secondLevel.closest('.at-advanced-menu__inner').querySelector(`.at-nav-level-third #${secondLevel.id}`);
      secondLevel.closest('.at-advanced-menu__inner').querySelectorAll('.at-nav-level-third__inner').forEach((thirdLevel) => thirdLevel.classList.add('at-hidden'));
      if (toshow) toshow.classList.remove('at-hidden');
    });
  });
}

init();
